import { useWeb3React } from '@web3-react/core';
import { convertUtf8ToHex } from '@walletconnect/utils';

function useSignMessage() {
  const { library, account } = useWeb3React();

  const signMessage = async (message: string) => {
    try {
      if (!message || typeof message !== `string`) {
        throw new Error(`message is not defined `);
      }
      // encode message (hex)
      const hexMsg = convertUtf8ToHex(message);

      const data = await library.send(`personal_sign`, [account, hexMsg]);

      return data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return null;
    }
  };
  return signMessage;
}

export default useSignMessage;
